import {RootState} from "../store";

const UISelectors = {
  getSidebarCollapsed: (state: RootState) => state.ui.collapse,
  getCurrentSelectedMenu: (state: RootState) => state.ui.currentSelectedMenu,
  
}

export default UISelectors;